// extracted by mini-css-extract-plugin
module.exports = {"Container":"Footer_Container__3rmGn"};